export default __webpack_public_path__ + "static/instaPng-ac7f96e7b557ba811f99102029d9e275.png";